import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import store from './store'
//import * as Sentry from "@sentry/vue";
//import { BrowserTracing } from "@sentry/tracing";

// || ---- MIX PANEL --- ||
import VueMixpanel from 'vue-mixpanel'
Vue.use(VueMixpanel, {
  token: '3193a45bd7f8cb77f0fef486ee6350ba'
})

require('./bootstrap');
window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

// Main abstrak style
require('./assets/css/bootstrap.min.css');
require('./assets/css/font-awesome.css');
require('./assets/css/slick.css');
require('./assets/css/slick-theme.css');
require('./assets/css/sal.css');
require('./assets/css/magnific-popup.css');
require('./assets/css/green-audio-player.min.css');
require('./assets/css/odometer-theme-default.css');
require('./assets/css/rg-style.css');
require('./assets/css/gilroy-font.css');
// require('magnific-popup'); // magnific-popup

require('./assets/css/app.css');

Vue.component('image-from-source', require('./components/shared/ImageFromSource').default);

Vue.mixin({
  data: function () {
    return {
      get StorageURL() {
        return process.env.VUE_APP_STORAGE_URL;
      },
      get ApiDomain() {
        return process.env.VUE_APP_API_DOMAIN;
      },
      get AppURL() {
        return process.env.VUE_APP_FRONTEND_URL;
      },
      get AppLoginURL() {
        return process.env.VUE_APP_LOGIN_URL;
      },
      get StatusToken() {
        return process.env.VUE_APP_STATUS_TOKEN;
      },
      get StatusId() {
        return process.env.VUE_APP_STATUS_ID;
      },
      // get AppRegisterURL(){ //Deprecated
      //   return process.env.VUE_APP_REGISTER_URL;
      // },
      get ThirdSiteText() {
        return "Al aceptar, serás dirigido a una página ajena a <strong>RedGirasol</strong>, por lo que la seguridad de la página del tercero no depende ni es responsabilidad de <strong>RedGirasol</strong>. ¿Deseas continuar?";
      }
    }
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
    redirectThirdSite(url, text = this.ThirdSiteText, isBlank = true) {
      this.redirectThirdSiteNotification(url, text, isBlank);
    },
    async setRgStatsData(isOds = false){
      const hasRgStats = !isOds ? sessionStorage.getItem("rg_stats") : sessionStorage.getItem("ods_stats");
      // console.log(hasRgStats);
      if(hasRgStats === null) {
        const res = await this.publicApiGet("/api/get/rg-stats");
        await sessionStorage.setItem("rg_stats", JSON.stringify(res.data));
        await sessionStorage.setItem("ods_stats", JSON.stringify(res.data.impact_data));
        return !isOds ? res.data : res.data.impact_data
      } else {
        return JSON.parse(hasRgStats);
      }
    },
    async getQualification() {
      const qualification = sessionStorage.getItem("qualification");

      if (qualification === null) {
        const res = await this.publicApiGet("api/get/qualification-rate");
        await sessionStorage.setItem("qualification", JSON.stringify(res.data));
        return res.data;
      } else {
        return JSON.parse(qualification);
      }
    },
    async getLoanLimits() {
      const loanLimits = sessionStorage.getItem("loan_limits");

      if (loanLimits === null) {
        const res = await this.publicApiGet(`api/v1/forms/getLoanLimits`);
        await sessionStorage.setItem("loan_limits", JSON.stringify(res.data));
        return res.data;
      } else {
        return JSON.parse(loanLimits);
      }
    },
    async getLoanTerms() {
      const loanTerms = sessionStorage.getItem("loan_terms");

      if (loanTerms === null) {
        const res = await this.publicApiGet(`api/v1/forms/getLoanTerms`);
        await sessionStorage.setItem("loan_terms", JSON.stringify(res.data));
        return res.data;
      } else {
        return JSON.parse(loanTerms);
      }
    },
    async goToPage(page) {
      await this.$router.push({
        name: page
      });
      this.mobileToggle = false;
    },
    async getCATText(loanType) {
      const rgStats = await this.setRgStatsData();
      if(rgStats.cat_caption_by_loan_type) {
        const catCaptionArray = JSON.parse(rgStats.cat_caption_by_loan_type);
        const caption = catCaptionArray.find(cat => cat.loan_type === loanType);

        return caption.caption;
      } else {
        return "";
      }
      // const cat = sessionStorage.getItem("cat");
      // if (cat === null) { 
      //   const res = await axios.get('/api/public-footer-text');
      //   await sessionStorage.setItem("cat", JSON.stringify(res.data));
      //   return res.data;
      // } else {
      //   return JSON.parse(cat);
      // }
    }
  }
})

import publicApiHelper from "./helpers/publicApiHelper";
import appLinksHelper from "./helpers/appLinksHelper";
import validationsHelper from "./helpers/validationsHelper";
import alertsHelper from "@components/mixins/alerts";
import request from "@components/mixins/request";
Vue.mixin(publicApiHelper)
Vue.mixin(appLinksHelper)
Vue.mixin(alertsHelper);
Vue.mixin(request);
Vue.mixin(validationsHelper);

/*Sentry.init({
  Vue,
  dsn: "https://57aa5b81222544628cd5fad149e56bc1@o4504403686588416.ingest.sentry.io/4504414116052992",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["redgirasol.com", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});*/

new Vue({
  render: h => h(App),
  router,
  store,
  created: async function () {
    await this.setRgStatsData();
    await this.getQualification();
    await this.getLoanLimits();
    // await this.getCATText();
    const scripts = [
      "https://cdn.redgirasol.com/portal_template/js/vendor/jquery-3.6.0.min.js",
      "https://cdn.redgirasol.com/portal_template/js/vendor/bootstrap.min.js",
      "https://cdn.redgirasol.com/portal_template/js/vendor/jquery.nav.js",
      "https://cdn.redgirasol.com/portal_template/js/init_app.js"
    ];

    scripts.forEach(script => {
      let externalScript = document.createElement('script');
      externalScript.setAttribute('src', script);
      document.head.appendChild(externalScript);
    });

    this.$forceUpdate();
  }
}).$mount('#app')
